import React, { useState, useEffect } from 'react';
import { CommonInput } from '@/components/ui/common-input';
import { CommonSelect } from '@/components/ui/common-select';
import MapSelector from '@/components/ports/addports/MapSelector';
import masterDataService from '@/services/masterDataService';

const DistributorProfile = ({ 
  distributorProfile, 
  errors, 
  onProfileChange 
}) => {
  const [coordinates, setCoordinates] = useState({
    lat: distributorProfile.latitude ? parseFloat(distributorProfile.latitude) : null,
    lng: distributorProfile.longitude ? parseFloat(distributorProfile.longitude) : null
  });
  
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);

  useEffect(() => {
    if (distributorProfile.latitude || distributorProfile.longitude) {
      setCoordinates({
        lat: distributorProfile.latitude ? parseFloat(distributorProfile.latitude) : null,
        lng: distributorProfile.longitude ? parseFloat(distributorProfile.longitude) : null
      });
    }
  }, [distributorProfile.latitude, distributorProfile.longitude]);


  useEffect(() => {
    const fetchStates = async () => {
      try {
        setLoadingStates(true);
        const statesData = await masterDataService.getStates(true);
        setStates(statesData || []);
      } catch (error) {
        console.error('Failed to fetch states:', error);
      } finally {
        setLoadingStates(false);
      }
    };

    fetchStates();
  }, []);

 
  useEffect(() => {
    const fetchDistricts = async () => {
      if (distributorProfile.state_id) {
        try {
          setLoadingDistricts(true);
          const districtsData = await masterDataService.getDistrictsByState(distributorProfile.state_id, true);
          setDistricts(districtsData || []);
          
         
          if (distributorProfile.district_id && !districtsData?.some(d => d.id === distributorProfile.district_id)) {
            onProfileChange('distributor_profile', 'district_id', '');
          }
        } catch (error) {
          console.error('Failed to fetch districts:', error);
          setDistricts([]);
        } finally {
          setLoadingDistricts(false);
        }
      } else {
        setDistricts([]);
      
        onProfileChange('distributor_profile', 'district_id', '');
      }
    };

    fetchDistricts();
  }, [distributorProfile.state_id]);

  const handleLocationSelect = (location) => {
    setCoordinates(location);
    onProfileChange('distributor_profile', 'latitude', location.lat.toString());
    onProfileChange('distributor_profile', 'longitude', location.lng.toString());
  };


  const stateOptions = states.map(state => ({
    value: state.id,
    label: state.name
  }));

 
  const districtOptions = districts.map(district => ({
    value: district.id,
    label: district.name
  }));

  return (
     <div className="">
      <div className="p-1">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <CommonInput
            label="Company Name"
            id="company_name"
            value={distributorProfile.company_name}
            onChange={(e) => onProfileChange('distributor_profile', 'company_name', e.target.value)}
            error={errors.company_name}
            required
            placeholder="Enter company name"
          />
          <CommonInput
            label="Contact Person"
            id="contact_person"
            value={distributorProfile.contact_person}
            onChange={(e) => onProfileChange('distributor_profile', 'contact_person', e.target.value)}
            placeholder="Enter contact person name"
          />
          
        
          <CommonSelect
            label="State"
            id="state_id"
            value={distributorProfile.state_id || ''}
            onValueChange={(value) => {
              onProfileChange('distributor_profile', 'state_id', value);
            
              onProfileChange('distributor_profile', 'district_id', '');
            }}
            options={stateOptions}
            error={errors.state_id}
            placeholder="Select state"
            searchable
            loading={loadingStates}
          />
          
       
          <CommonSelect
            label="District"
            id="district_id"
            value={distributorProfile.district_id || ''}
            onValueChange={(value) => onProfileChange('distributor_profile', 'district_id', value)}
            options={districtOptions}
            error={errors.district_id}
            placeholder="Select district"
            searchable
            loading={loadingDistricts}
            disabled={!distributorProfile.state_id}
          />
          
          <div className="md:col-span-2">
            <CommonInput
              label="Address"
              id="address"
              value={distributorProfile.address}
              onChange={(e) => onProfileChange('distributor_profile', 'address', e.target.value)}
              placeholder="Enter address"
            />
          </div>
          <div className="md:col-span-2">
            <MapSelector
              onLocationSelect={handleLocationSelect}
              initialLat={coordinates.lat}
              initialLng={coordinates.lng}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistributorProfile;